export default __webpack_public_path__ + "static/media/nav_detail_img_9.085d38cf.jpg";